<template>
  <div class="mb-container mb-eseal-wrap">
    <div @click="chooseSeal" class="seal" v-if="!isChoosed">
      <span class="sealIcon">+</span>
      <span>添加印章</span>
    </div>
    <div @click="chooseSeal" v-if="isChoosed" class="seal_choosed" :style="{
        left: posX ? posX + 'px' : 0,
        top: posY ? posY + 'px' : 0,
      }">
      <img @touchmove="onmove" :src="
          choosedSeal.downloadUrl
            ? choosedSeal.downloadUrl
            : choosedSeal.sealBase64
        "
        alt="" class="sealImg" />
      <div @click.stop="deleteSeal" v-if="canDelete" v-show="showDelete" class="sealDeleteButton">
        删除
      </div>
    </div>
    <div class="modal" @mousewheel.prevent @click.self="changeModal" v-if="isShowModal"></div>

    <!-- <div v-if="flag">
      <div
        class="move-div"
        v-for="(item, index) in sealInfoList"
        @touchmove="onmove($event, item, index)"
        :key="item + index"
        :style="{
          left: item.posX ? item.posX + 'px' : posX + 'px',
          top: item.posY ? item.posY + 'px' : posY + 'px',
        }"
      >
        <div v-if="item.lose" class="lose">失效</div>
        <img
          :src="item.url ? item.url : item.sealBase64"
          alt=""
          @click.self="checkSeal(item)"
        />
      </div>
    </div> -->
    <div class="mb-pop" :style="{ height: isShowModal ? '318px' : '0' }">
      <div class="mb-pop_header">
        <span class="seal-type" :class="type === 'person' ? 'is-active' : ''" @click="changeType('person')">个人章</span>
        <span class="seal-comp" :class="type === 'comp' ? 'is-active' : ''" @click="changeType('comp')">{{ choosedComp.departmentName }}</span>
        <div class="go-icon" @click="goChoose"></div>
      </div>

      <div v-if="type === 'person'" class="mb-pop_body" ref="box">
        <div class="flex-item">
          <div class="hand" @click="showHand">
            <div class="add">+</div>
            <div class="sign-text">手绘签名</div>
          </div>
        </div>
        <div class="hand-signature-wrap">
          <div class="flex-item" v-for="(item, index) in handSealList" :key="index"  v-show="item.sealBase64">
            <img :src="item.sealBase64" alt="" @click="clickSeal(item)" />
          </div>
        </div>
        <div class="personal-seal-wrap">
          <div class="flex-item" v-for="(item, index) in personalSealList" :key="index" v-show="item.downloadUrl"> 
            <img :src="item.downloadUrl" alt="" @click="clickSeal(item)" />
          </div>
        </div>
      </div>
      <div v-if="type === 'comp'" class="mb-pop_body" ref="box">
        <div class="flex-item" v-for="(item, index) in comSealList" :key="index" v-show="item.downloadUrl">
          <img :src="item.downloadUrl" alt="" @click="clickSeal(item)" />
        </div>
      </div>
    </div>

    <div class="mb-seal_choose" v-if="isChooseComp">
      <div class="comp-bg">
        <div class="choose-header">
          <div class="choose-cancel" @click="onCancle">取消</div>
          <div class="choose-title">请选择企业</div>
          <div class="choose-cancel"></div>
        </div>

        <div class="mb-seal_body">
          <div class="seal-item" v-for="(item, index) in compList" :key="index" @click="chooseComp(item)">
            {{ item.departmentName }}
          </div>
        </div>
      </div>
    </div>
    <div class="seal-dialog" v-if="showCheck">
      <div class="top">
        <span class="title">电子签章</span>
        <span @click="closeCheck" class="closeIcon">x</span>
      </div>
      <div class="check">
        <div v-if="checkForm.length == 0 && checkInfo.isSuccess">
          <div class="check-icon_succ"></div>
          <div class="check-text">
            验签成功
          </div>
        </div>
        <div v-else>
          <div class="check-icon"></div>
          <div class="check-text">
            验签失败
          </div>
        </div>
      </div>
      <div class="tab">
        <div class="tab-head" :class="showInfo ? 'tab-head_active' : ''" @click="changeTab(true)">
          验签信息
        </div>
        <div v-if="checkForm.length != 0 || !checkInfo.isSuccess" class="tab-head" :class="showInfo ? '' : 'tab-head_active'"
          @click="changeTab(false)">
          篡改信息
        </div>
        <div v-show="showInfo" class="tab-body">
          <div v-for="(val, key) in checkInfo.baseInfo" :key="key" class="clearfix">
            <label class="kg-label">{{ infoMap[key] }}:</label><span class="kg-value">{{ val }}</span>
          </div>
        </div>
        <div v-show="!showInfo" class="tab-body">
          <div class="info-item">{{ checkInfo.message }}</div>
          <div v-for="(item, index) in checkForm" :key="index" class="info-item">
            <div>{{ item.protectName }}由:{{ item.origin }}</div>
            <div class="biangen">变更为:{{ item.change }}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <button @click="closeCheck">关闭</button>
      </div>
    </div>
    <purpose-mb :show="isShowPurpose" @check-succ="checkSucc"></purpose-mb>
    <hand v-if="isShowHandWrite" @hand-write="getBase64"></hand>
  </div>
</template>

<script>
  /* eslint-disable */
  import purposeMb from './purposeMb.vue'
  import signature from './signature.vue'
  export default {
    name: "mb",
    components: {
      "purpose-mb": purposeMb,
      hand: signature,
    },
    mounted() {
      var that = this
      // this.reFindSealList()
      this.getCompList().then(function() {
        that.getComSealById()
      })
    },
    watch: {
      isShowModal: function(val) {
        this.$refs.box.removeEventListener("scroll", this.handleScroll)
        this.$nextTick(function() {
          this.$refs.box.addEventListener("scroll", this.handleScroll)
        })
        if (val) {
          handler.sealShowLogic && handler.sealShowLogic()
        } else {
          handler.sealHideLogic && handler.sealHideLogic()
        }
      },
      showCheck() {
        this.showInfo = true
      },
      isShowPurpose(val) {
        if (val) {
          handler.sealShowLogic && handler.sealShowLogic()
        } else {
          handler.sealHideLogic && handler.sealHideLogic()
        }
      }
    },

    data: function() {
      return {
        flag: true,
        posX: "",
        posY: "",
        type: "comp",
        choosedSeal: "",
        choosedComp: {},
        checkForm: [],
        showInfo: false,
        checkInfo: {},
        showCheck: false,
        canDelete: true,
        showDelete: false, //是否展示删除按钮
        checkPurpuse: false, //意愿认证结果
        isChooseComp: false, //当前是选怎什么类型章
        isShowModal: false, //选择印章
        isShowPurpose: false,
        isShowHandWrite: false,
        isChoosed: false, // 是否选中章
        authRecordId: "",
        compList: [],
        sealInfoList: [], //合同上已有的章S
        personalSealList: [], //个人章列表
        handSealList: [], //手写的章列表
        comSealList: [], //公司章
        pageIndex: 1,
        infoMap: {
          userName: "用户名称",
          mainBody: "签署主体",
          sealName: "签章名称",
          signTime: "签署时间",
        },
      }
    },
    methods: {
      clickSeal: function(item) {
        item.newAdd = true
        this.isChoosed = true
        this.choosedSeal = item
        this.isShowModal = false
        // eslint-disable-next-line
        handler && handler.chooseSeal && handler.chooseSeal(this.choosedSeal)
      },
      deleteSeal: function() {
        this.posX = 0
        this.posY = 0
        this.showDelete = false
        this.seal = {}
        this.isChoosed = false
        // eslint-disable-next-line
        handler && handler.deletedSeal && handler.deletedSeal()
      },
      handleScroll: function() {
        if (
          this.$refs.box.scrollLeft + this.$refs.box.clientWidth ===
          this.$refs.box.scrollWidth
        ) {
          if (this.$refs.box.scrollLeft == 0) {
            return
          }
          if (this.type == "person") {
            this.reFindPersonalSealList()
          }
          if (this.type == "comp") {
            this.getComSealById()
          }
        }
      },
      chooseComp: function(item) {
        this.onCancle()
        this.choosedComp = item
        this.pageIndex = 1
        this.comSealList = []
        this.getComSealById()
      },
      closeCheck: function() {
        this.showCheck = false
      },
      onmove: function(event) {
        // if()
        //阻止默认事件，如果不添加，拖动时，内容会跟着跑。
        event.preventDefault()
        //拿到坐标
        //  event.target.height 获取不准，后面探究
        var x = event.touches[0].clientX - 65
        var y = event.touches[0].clientY - 65
        // 为了取中心点，所以X轴和Y轴各减一半

        this.posX = x.toFixed(2)
        this.posY = y.toFixed(2)
        // this.flag = false
        // this.$nextTick(function () {
        //   this.flag = true
        // })
      },

      submit: function() {
        //pc 和h5都有这两个方法提交时进行意愿认证
        if (!this.checkPurpuse) {
          this.isShowPurpose = true
        } else {
          this.checkSucc()
        }
      },
      // 获取公司列表
      getCompList: function() {
        var that = this
        return $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/esignpro/rest/seal/getAccountIdSealManage",
          type: "post",
          headers: {
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: {
            // eslint-disable-next-line
            accountId: handler.userInfo.id,
          },
          success: function(data) {
            that.compList = data.data.sealManageBeans
            that.choosedComp = data.data.sealManageBeans[0]
          },
          error: function(data) {
            console.log(data)
          },
        })
      },
      getComSealById: function() {
        var that = this
        $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/V1/seals/innerOrgansSeals/plug/list",
          type: "get",
          headers: {
            Authorization: "authorization",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
            "x-timevale-project-id": "1000000",
          },
          data: {
            organizeId: that.choosedComp.departmentId,
            // eslint-disable-next-line
            accountId: handler.userInfo.id,
            pageIndex: that.pageIndex,
            pageSize: 10,
          },
          success: function(data) {
            if (data.errCode == 0) {
              that.pageIndex++
              for (var i in data.data.seals) {
                data.data.seals[i].departmentId = that.choosedComp.departmentId
                that.comSealList.push(data.data.seals[i])
              }
            }
          },
          error: function(data) {
            console.log("error", data)
          },
        })
      },
      changeTab: function(boo) {
        this.showInfo = boo
      },
      chooseSeal: function() {
        if (this.isChoosed) {
          this.showDelete = !this.showDelete
        } else {
          this.isShowModal = true
        }
      },

      changeModal: function() {
        this.isShowModal = !this.isShowModal
      },
      goChoose: function() {
        this.isChooseComp = true
        this.isShowModal = false
      },
      onCancle: function() {
        this.isShowModal = true
        this.isChooseComp = false
      },
      changeType: function(type) {
        this.pageIndex = 1
        this.type = type
        this.comSealList = []
        this.personalSealList = []
        if (type === "person") {
          this.reFindPersonalSealList()
        } else {
          this.getComSealById()
        }
      },
      showHand: function() {
        // this.isShowModal = false
        this.isShowHandWrite = true
      },
      getBase64: function(obj) {
        this.handSealList.push(obj)
      },
      // 点击验签
      checkSeal: function(item) {
        this.showCheck = true //把这个写在接口回调
        this.checkInfo = {
          isSuccess: true,
          message: "",
        }
        this.checkSealOne(item)
      },
      checkSealAll: function() {
        var that = this
        // if (item.newAdd) {
        //   return
        // }
        var list = []
        for (var i in this.sealInfoList) {
          var a = {
            signlogId: this.sealInfoList[i].signlogId,
            timestampId: this.sealInfoList[i].timestampId,
            businessProcessId: this.sealInfoList[i].businessProcessId,
            signatureList: [{
              sealName: this.sealInfoList[i].alias ?
                this.sealInfoList[i].alias :
                this.sealInfoList[i].sealName,
              // eslint-disable-next-line
              userName: handler.userInfo.name,
              describe: this.sealInfoList[i].describeData,
              sealId: this.sealInfoList[i].sealRequestId,
            }, ],
          }
          list.push(a)
        }
        console.log("verify list", list)
        $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/esignpro/rest/sign/verifySign2",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: JSON.stringify({
            signatureList: list,
          }),
          success: function(data) {
            for (let i in data.data) {
              if (!data.data[i].result.success) {
                for (let j in that.sealInfoList) {
                  if (data.data[i].sealId == that.sealInfoList[j].sealRequestId) {
                    // eslint-disable-next-line
                    handler.addLose(that.sealInfoList[j])
                  }
                }
              }
              if (data.data[i].result.success) {
                for (let j in that.sealInfoList) {
                  if (data.data[i].sealId == that.sealInfoList[j].sealRequestId) {
                    // eslint-disable-next-line
                    handler.verifySuccess(that.sealInfoList[j])
                  }
                }
              }
            }

            return data.data
            //返回失效的数组
          },
          error: function(data) {
            console.log("error", data)
          },
        })
      },

      //单个验签
      checkSealOne: function name(item) {
        console.log(item, 111)
        var that = this
        $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/esignpro/rest/sign/verifySign2",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: JSON.stringify({
            signatureList: [{
              signlogId: item.signlogId,
              timestampId: item.timestampId,
              businessProcessId: item.businessProcessId,
              signatureList: [
                //11111
                {
                  sealName: item.alias ? item.alias : item.sealName,
                  // eslint-disable-next-line
                  userName: handler.userInfo.name,
                  describe: item.describeData,
                  sealId: item.sealRequestId,
                },
              ],
            }, ],
          }),
          success: function(data) {
            if (data.errCode === 0) {
              var a = JSON.parse(JSON.stringify(data.data[0]))
              delete a.result
              delete a.sealId //222222
              if (data.data[0].result.success) {
                that.checkInfo = {
                  isSuccess: true,
                  message: "验签成功",
                  baseInfo: a,
                }
              } else {
                // eslint-disable-next-line
                handler.addLose(item) //修改
                that.checkInfo = {
                  isSuccess: false,
                  message: data.data[0].result.message,
                  baseInfo: a,
                }
              }
            }
          },
          error: function(data) {
            console.log("error", data)
          },
        })
      },
      //查找个人印章
      reFindPersonalSealList: function() {
        var that = this
        $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/V1/seals/innerPersonalSeals/list",
          type: "get",
          headers: {
            Authorization: "authorization",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
            "x-timevale-project-id": "1000000",
          },
          data: {
            // eslint-disable-next-line
            accountId: handler.userInfo.id,
            pageIndex: that.pageIndex,
            pageSize: 10,
          },
          success: function(data) {
            if (data.errCode == 0) {
              that.pageIndex++;
              let dataList=data.data.seals||[];
              if(dataList.length){
                for (var i in dataList) {
                  that.personalSealList.push(data.data.seals[i])
                }
              }
            }
          },
          error: function(data) {
            console.log("error", data)
          },
        })
      },
      //查询合同上已有签章
      reFindSealList: function() {
        var that = this
        $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/V1/sealCoordinates/queryByBusinessProcessId",
          type: "post",
          headers: {
            "x-timevale-project-id": 1000000,
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: {
            // eslint-disable-next-line
            businessProcessId: handler.businessProcessId,
          },
          success: function(data) {
            if (data.errCode == 0) {
              that.sealInfoList = data.data
              if (data.errCode == 0) {
                that.sealInfoList = data.data
                if (that.sealInfoList.length > 0) {
                  // eslint-disable-next-line
                  var signs = handler.setPos(data.data)
                  that.sealInfoList = signs
                  for (var i in signs) {
                    signs[i].uuid = that.getuuid()
                    signs[i].describeData = JSON.stringify(
                      // eslint-disable-next-line
                      handler.verifyData(JSON.parse(signs[i].describeData))
                    )
                    // eslint-disable-next-line
                    handler.run(signs[i])
                  }

                  //渲染完毕调用loadSignature方法,用户决定是否验签
                  // eslint-disable-next-line
                  handler.loadSignature()
                }
              }
            }
          },
          error: function(err) {
            console.log(err)
          },
        })
      },

      checkSucc() {
        this.checkPurpuse = true
        // var list = [] //所有新增的印章信息
        // var sealIdList = [] //新增印章id集合
        // for (var i in this.sealInfoList) {
        //   this.sealInfoList[i].index = i
        //   if (this.sealInfoList[i].newAdd) {
        //     var a =
        //       this.sealInfoList[i].sealId ||
        //       this.sealInfoList[i].sealRequestId ||
        //       this.sealInfoList[i].sealUUID
        //     sealIdList.push({
        //       organizeId: this.sealInfoList[i].departmentId
        //         ? this.sealInfoList[i].departmentId
        //         : "", //有机构id就传机构id,没有就传用户id
        //       accountId: this.sealInfoList[i].departmentId
        //         ? ""
        //         : handler.userInfo.id,
        //       sealId: a,
        //       sealIndex: i, // 通过角标重新定位新增印章，将获取的验签信息塞回去用来验签
        //     })
        //     list.push(this.sealInfoList[i])
        //   }
        // }
        this.reSubmit()
      },
      reSubmit: function() {
        console.log(44444)
        if (JSON.stringify(this.choosedSeal) == "{}") {
          return
        }
        var list = [{
          sealBase64: this.choosedSeal.sealBase64 || "",
          sealId: this.choosedSeal.sealId || this.choosedSeal.sealUUID || "",
          sealUrl: this.choosedSeal.downloadUrl,
          sealHand: this.choosedSeal.ishand ? this.choosedSeal.ishand : false,
          type: this.choosedSeal.sealType == 1 ? 1 : 0,
          organizeId: this.choosedSeal.departmentId, //11111
        }, ]

        var d = Date.now()
        d -= d % (60 * 1000)
        var that = this
        return $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/esignpro/rest/sign/api/hashSignWithTimestamp2",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: JSON.stringify({
            // eslint-disable-next-line
            accountUniqueId: handler.userInfo.uniqueId,
            // eslint-disable-next-line
            accountId: handler.userInfo.id,
            // eslint-disable-next-line
            businessProcessId: handler.businessProcessId,
            authRecordId: that.authRecordId, //
            certId: "",
            // eslint-disable-next-line
            describe: handler.setProtect(),
            sealId: "", //
            sealList: list,
            signIp: "",
            time: d,
            timestampSwitch: 1,
            ///这里拿出来了
          }),
          success: function(data) {
            if (data && data.data[0].success) {
              that.save(data.data[0]) //保存坐标
            } else {
              alert(data.data[0].message)
            }
          },
          error: function(data) {
            console.log("error", data)
          },
        })
      },
      save: function(e) {
        console.log("ddasdasdasdadsadas")
        var that = this
        $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/V1/sealCoordinates/saveCoordinates",
          type: "post",
          headers: {
            "Content-Type": "application/json;charset=utf8",
            "Access-Control-Allow-Methods": "GET, POST, PUT,DELETE,OPTIONS,PATCH",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: JSON.stringify({
            sealRequestId: e.sealId,
            businessProcessId: e.businessProcessId,
            url: e.sealUrl,
            posX: that.posX,
            posY: that.posY,
            sealBase64: e.sealBase64,
            signlogId: e.signlogId,
            timestampId: e.timestampId,
            sealName: this.choosedSeal.alias ||
              this.choosedSeal.sealName ||
              // eslint-disable-next-line
              handler.userInfo.name + "手绘", //1111
            // eslint-disable-next-line
            userName: handler.userInfo.name,
            // eslint-disable-next-line
            describeData: JSON.stringify(handler.setProtect()),
          }),
          success: function(data) {
            if (data.errCode === 0) {
              that.canDelete = false
              that.showDelete = false
              // eslint-disable-next-line
              handler.submitHook && handler.submitHook(e.signlogId)
              // that.choosedSeal = {} 移动端不需要清空
            }
          },
          error: function(data) {
            console.log("error", data)
          },
        })
      },
      getuuid: function() {
        var s = []
        var hexDigits = "0123456789abcdef"
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = "4" // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-"

        var uuid = s.join("")
        this.uuid = uuid
        return uuid
      },
      getBase64Src: function(item) {
        let base64File
        $.ajax({
          // eslint-disable-next-line
          url: handler.severUrl + "/V1/seals/getSealBase64",
          type: "get",
          async: false,
          headers: {
            "Access-Control-Allow-Methods": "GET, POST, PUT,DELETE,OPTIONS,PATCH",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: {
            type: 0,//item.sealType == 1 ? 1 : 0 //只有内部章
            sealId: item.sealId ? item.sealId : item.sealRequestId,
          },
          success: function(data) {
            if (data.errCode === 0) {
              base64File = data.data && data.data.sealBase64
            }
          },
          error: function(data) {
            console.log("error", data)
          },
        })
        return base64File
      },
    },
  }
</script>

<style scoped>
  .mb-container {
    overflow: hidden;
    width: 100vh;
  }

  .mb-eseal-wrap .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    z-index: 999;
  }

  .mb-pop {
    box-sizing: border-box;
    border-radius: 3% 3% 0 0;
    position: fixed;
    padding: 0 5%;
    height: 318px;
    width: 100vw;
    left: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 1000;
    background: #ffffff;
    transition: height 0.5s;
  }

  .mb-pop_header {
    position: relative;
    font-family: PingFangSC-Regular;
    color: #1a1a1a;
    height: 44px;
    width: 339px;
    margin: 0 auto;
    margin-top: 10px;
    border-bottom: solid 1px #bfbfbf;
    display: flex;
  }

  .mb-pop_header .seal-type {
    font-size: 14px;
    line-height: 44px;
  }

  .mb-pop_header .seal-comp {
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #1a1a1a;
    margin-left: 10%;
    line-height: 44px;
  }

  .is-active {
    font-family: PingFangSC-Medium;
    border-bottom: solid 2px #e63740;
  }

  .go-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    background: url("./icon/go.png") no-repeat center center;
    background-size: 100% 100%;
    right: 0;
    top: 14px;
  }

  .mb-seal_choose {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 998;
    background-color: #f0f0f0;
  }

  .choose-header {
    display: flex;
    width: 100%;
    height: 38px;
    font-size: 14px;
    padding: 0 20px;
    border-bottom: solid 2px #f7f8fa;
  }

  .choose-cancel {
    font-family: PingFangSC-Regular;
    line-height: 38px;
    font-size: 16px;
    color: #333333;
    width: 20%;
  }

  .choose-title {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    line-height: 38px;
    color: #1a1a1a;
    width: 50%;
    text-align: center;
  }

  .mb-seal_body {
    width: 100%;
  }

  .seal-item {
    line-height: 50px;
    height: 50px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #1a1a1a;
    padding: 0 20px;
    border-bottom: solid 2px #f7f8fa;
  }

  .mb-pop_body {
    display: flex;
    margin: 0 auto;
    width: 339px;
    height: 274px;
    overflow-x: auto;
  }

  .hand-signature-wrap,
  .personal-seal-wrap {
    display: flex;
  }

  .personal-seal-wrap:empty,
  .hand-signature-wrap:empty {
    margin-left: 0;
  }

  .flex-item {
    padding-top: 30px;
  }

  .flex-item:not(:first-child),
  .personal-seal-wrap,
  .hand-signature-wrap {
    margin-left: 30px;
  }

  .flex-item img {
    width: 150px;
    height: 150px;
  }

  .comp-bg {
    background: #ffffff;
  }

  .hand {
    width: 150px;
    height: 150px;
    background: #f5f5f5;
    overflow: hidden;
  }

  .hand .add {
    text-align: center;
    width: 50%;
    font-size: 40px;
    color: #b3b3b3;
    margin: 0 auto;
    margin-top: 20px;
  }

  .sign-text {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #b3b3b3;
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .move-div {
    position: absolute;
    width: 130px;
    height: 130px;
  }

  .move-div img {
    width: 130px;
    height: 130px;
  }

  .seal-dialog {
    position: fixed;
    top: 10%;
    left: 3%;
    right: 3%;
    /* width: 320px; */
    height: 600px;
    background-color: #fff;
    z-index: 99;
  }

  .seal-dialog .top {
    position: relative;
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #e8e8e8;
  }

  .seal-dialog .top span {
    position: absolute;
    line-height: 50px;
  }

  .seal-dialog .top .title {
    left: 24px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }

  .seal-dialog .top .closeIcon {
    right: 24px;
    font-size: 18px;
    color: #bfbfbf;
    cursor: pointer;
  }

  .check-icon {
    margin: 0 auto;
    margin-top: 40px;
    width: 60px;
    height: 60px;
    background: url("./icon/rejected.svg") no-repeat center center;
    background-size: 100% 100%;
    height: 60px\9 !important;
    width: 60px\9 !important;
  }

  .check-icon_succ {
    margin: 0 auto;
    margin-top: 40px;
    width: 60px;
    height: 60px;
    background: url("./icon/success.png") no-repeat center center;
    background-size: 100% 100%;
    height: 60px\9 !important;
    width: 60px\9 !important;
  }

  .check-text {
    width: 50%;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    font-size: 18px;
    color: #666666;
  }

  .footer {
    position: absolute;
    bottom: 30px;
    right: 20px;
  }

  .footer button {
    border: none;
    margin-right: 15px;
    width: 72px;
    height: 32px;
    border-radius: 3px;
    font-size: 14px;
    outline: none;
    cursor: pointer;
    background-color: #fff;
    color: #666666;
    border: 1px solid #d9d9d9;
  }

  .tab {
    width: 100%;
    margin: 0 auto;
    display: table;
  }

  .tab-head {
    position: relative;
    display: inline-block;
    width: 109px;
    height: 33px;
    background: #f7f8fa;
    border: 1px solid rgba(0, 0, 0, 0.09);
    text-align: center;
    line-height: 33px;
  }

  .tab-head_active::after {
    content: "";
    height: 2px;
    width: 60px;
    background: #307bf6;
    position: absolute;
    bottom: 0;
    left: calc(50% - 30px);
  }

  .tab-body {
    height: 257px;
    background: #f7f8fa;
    border: 1px solid rgba(0, 0, 0, 0.09);
    padding: 20px;
    word-break: break-all;
    overflow-y: auto;
  }

  .info-item {
    margin-top: 10px;
  }

  .biangen {
    margin-top: 10px;
  }

  .kg-label {
    float: left;
    text-align: right;
  }

  .kg-value {
    float: left;
    max-width: 75%;
    text-align: left;
    word-break: break-all;
  }

  .clearfix {
    margin-top: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }

  .seal {
    position: relative;
    width: 100px;
    height: 100px;
    background-color: #f8f8f8;
    border: 1px solid #e8e9ec;
    cursor: pointer;
    font-size: 14px;
    color: #316cf1;
  }

  .seal span {
    display: block;
    text-align: center;
  }

  .seal .sealIcon {
    font-size: 38px;
    font-weight: bold;
    margin-top: 10px;
  }

  .lose {
    position: absolute;
    width: 90px;
    height: 30px;
    line-height: 30px;
    top: 44px;
    left: 18px;
    font-size: 26px;
    text-align: center;
    color: gray;
    border: 5px solid;
  }

  .seal_choosed {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #f8f8f8;
  }

  .seal_choosed .sealImg {
    width: 100%;
    height: 100%;
  }

  .sealDeleteButton {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 20px;
    background-color: #316cf1;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
  }
</style>
